<div *ngIf="numericAttribute" class="content-subcontainer">
  <div class="content-input">
    <span *ngIf="showLabel"> {{ getLocalizedString(numericAttribute.infoText) }} </span>

    <div class="input-wrapper">

      <input class="keyboard-input" *ngIf="(mode$|async)?.includes(numericAttributeModeEnum.Number)" [appUnitConversion]="unitFactor"
        (change)="onInputChange()" (input)="onInput()" [unit]="unit" #myDirective="appUnitConversion" #input
        type="number" [(ngModel)]="current" [min]="numericAttribute.min" [max]="numericAttribute.max"
        [step]="numericAttribute.step">


      <!-- <mat-slider *ngIf="(mode$|async)?.includes(numericAttributeModeEnum.Slider)" class="slider" (input)="onInput(true)"
        (change)="onInputChange()" [min]="numericAttribute.min" [max]="numericAttribute.max"
        [step]="numericAttribute.step">
        <input matSliderThumb [(ngModel)]="current">
      </mat-slider> -->

      <input
  #rangeInput
  *ngIf="(mode$|async)?.includes(numericAttributeModeEnum.Slider)"
  class="slider"
  type="range"
  [min]="numericAttribute.min"
  [max]="numericAttribute.max"
  [step]="numericAttribute.step"
  [(ngModel)]="current"
  (input)="onInput(true); updateSlider()"
  (ngModelChange)="updateSlider()"
  (change)="onInputChange()"
/>



      <mat-form-field *ngIf="(mode$|async)?.includes(numericAttributeModeEnum.Select)" class="input-select">
        <mat-select (selectionChange)="onInputChange($event)" [value]="current">
          <div *ngFor="let value of possibleValues" matTooltipPosition="right"
            [matTooltip]="parseReason(checkIfValueCanBeSet(value))">

            <mat-option [disabled]="!checkIfValueCanBeSet(value).isAvailible"
              [value]="value">{{value|unitConversion:unitFactor:unit}}</mat-option>

          </div>


        </mat-select>
      </mat-form-field>

    </div>




    <button *ngIf="showConfirmButton &&(mode$|async)?.includes(numericAttributeModeEnum.Number) " class="confirm-numeric-button"
      mat-button (pointerdown)="confirmInput()">
      <mat-icon> check </mat-icon>
    </button>
  </div>
  <span *ngIf="isInputChanged | async"
    class="notification-text">{{ 'translations.numeric-input-notification' | translate }}</span>
</div>
